
import { prop, Vue, Options } from "vue-class-component";

class Props {
  show = prop<boolean>({
    required: true,
    default: false
  });
  guide = prop<any>({
    required: true
  });
}

@Options({})
export default class PopUpCarousel extends Vue.with(Props) {
  currentSlide = 0;

  nextSlide() {
    if (this.guide && this.currentSlide < this.guide.carousel_list.length - 1) {
      this.currentSlide++;
    }
  }

  prevSlide() {
    if (this.currentSlide > 0) {
      this.currentSlide--;
    }
  }

  onClose() {
    this.$emit("update:show", false);
    this.currentSlide = 0;
  }
}
